<template>
    <div class="tw:relative tw:space-y-1">
        <button type="button" @click="$emit('toggle')" :title="expanded ? null : title" :aria-expanded="open ? 'true' : 'false'"
            class="tw:w-full tw:flex tw:items-center tw:justify-between tw:px-3.5 tw:py-2.5 tw:rounded-xl tw:text-sm tw:bg-transparent tw:border-0 tw:cursor-pointer tw:transition-all"
            :class="active
                ? 'tw:bg-brand-primary/15 tw:text-brand-primary tw:font-semibold'
                : 'tw:font-medium tw:text-slate-400 tw:hover:bg-slate-800/70 tw:hover:text-slate-200'">
            <div class="tw:flex tw:items-center tw:gap-3 tw:min-w-0">
                <i :class="icon" class="tw:text-sm tw:w-4 tw:shrink-0 tw:text-center"></i>
                <span class="tw:truncate" v-show="expanded">{{ title }}</span>
            </div>
            <i v-if="expanded"
                class="fas fa-chevron-right tw:text-[10px] tw:text-slate-500 tw:transition-transform tw:duration-200"
                :class="{ 'tw:rotate-90': open }"></i>
        </button>

        <div v-show="open && expanded" class="tw:pl-9 tw:pr-2 tw:py-1 tw:space-y-1">
            <slot></slot>
        </div>
    </div>
</template>

<script>
export default {
    name: 'SidebarGroup',
    props: {
        icon: { type: String, default: '' },
        title: { type: String, default: '' },
        active: { type: Boolean, default: false },
        open: { type: Boolean, default: false },
        expanded: { type: Boolean, default: true },
    },
}
</script>
